import { Component } from '@angular/core';
import { UserManagementService } from "../userManagement/user-management.service";
import { ApiResponse } from '../../models/api-response';
import { NotificationService } from "../../services/notification.service";
import { UserDetails } from './user-details';
import { UserManagementRequest } from './user-management-request';

@Component({
    selector: 'user-management',
    template: require('./user-management.component.html')
})
export class UserManagementComponent{

    userName: string;
    firstName: string;
    lastName: string;
    emailId: string;
    phoneNumber: string;
    userId: string;
    hasUserDetails= false;
    responseData: any;
    detailsRetrieved=false;
    retrievedUserDetails: UserDetails = new UserDetails('', '', '', '', '', '', '', '', '');
    
    emailValidator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    guidValidatorRegex: RegExp = new RegExp('^[{(]?[0-9A-Fa-f]{8}[-]?([0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}[)}]?$');
    constructor(private userManagement: UserManagementService,
        private notifier: NotificationService) {
        this.notifier.clear();
    }
    
    clearMessages() {
        this.hasUserDetails = false;
        this.notifier.clear();
    }
    typeCastResponse(response: any): UserDetails {

        if (response.statusCode === 200) {
            this.hasUserDetails = true;
            var retrievedUserDetails = (<UserDetails>(<ApiResponse>(response)).data.userDetails);
            return retrievedUserDetails;

        }
        this.notifier.displayError(response.data.value);
        return new UserDetails( '', '', '', '', '', '', '', '', '');
    }

    addUser() {
        this.hasUserDetails = false;
        if (this.firstName == null || this.lastName == null || this.userName == null || this.phoneNumber == null || this.emailId == null) {
            this.notifier.displayError("Fields cannot be left empty. Please try again with a valid input.");
            return;
        }
       
        this.notifier.displayInfo("Attempting to add User to ForgeRock..");
        var userManagementRequest= new UserManagementRequest(this.userName,
            this.firstName,
            this.lastName,
            this.emailId,
            this.phoneNumber);
        this.userManagement.addUser(userManagementRequest).subscribe(
            resp => {
                this.notifier.clear();
                this.notifier.displaySuccess("Successfully created User. Details: ");
                this.responseData = resp;
                if (this.responseData)
                    this.retrievedUserDetails = this.typeCastResponse(this.responseData);
                
            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }

    fetchUserDetails() {
        this.detailsRetrieved = false;
        this.hasUserDetails = false;
        if (this.guidValidatorRegex.test(this.userId) === false) {
            this.notifier.displayError("Please enter a valid userId");
            return;
        } 
        this.notifier.displayInfo("Attempting to get details of User...");
        this.userManagement.getDetailsOfUser(this.userId).subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.notifier.displaySuccess("Successfully fetched the details of the user");
                if (this.responseData)
                    this.detailsRetrieved = true;
                    this.retrievedUserDetails = this.typeCastResponse(this.responseData);
                    
            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }

    fetchUserDetailsByUserName() {
        this.detailsRetrieved = false;
        this.hasUserDetails = false;
        if (this.userName == null) {
            this.notifier.displayError("The input field is empty. Please enter user name");
            return;
        }
        this.notifier.displayInfo("Attempting to get details of User...");
        this.userManagement.fetchUserDetailsByUserName(this.userName).subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.notifier.displaySuccess("Successfully fetched the details of the user");
                if (this.responseData) {
                    this.detailsRetrieved = true;
                }
                this.retrievedUserDetails = this.typeCastResponse(this.responseData);

            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            }
        );
    }

    deleteUser() {
        
        this.notifier.displayInfo("Attempting to delete User from ForgeRock..");
        this.userManagement.deleteUser(this.userId).subscribe(
            resp => {
                this.hasUserDetails = false;
                this.notifier.clear();
                this.responseData = resp;
                this.notifier.displaySuccess("Successfully deleted the user");
                this.detailsRetrieved = false;               
            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }

    initializeCurrentTab() {
        this.notifier.clear();
        this.retrievedUserDetails = new UserDetails('', '', '', '', '', '', '', '', '');
        this.hasUserDetails = false;
        this.detailsRetrieved = false;
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/userManagement/user-management.component.ts
 **/